import React from 'react'

const Privacy = () => {
  const lastUpdated = 'May 19, 2026'
  const contactEmail = 'privacy@forgen.ai'

  return (
    <div className="min-h-screen bg-white text-gray-900">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-bold mb-2">Privacy Policy</h1>
        <p className="text-sm text-gray-600 mb-8">Last updated: {lastUpdated}</p>

        <p className="mb-6">
          ForGen AI ("we", "us", or "our") builds mobile games, including
          <em> 21 Questions</em> and other titles (collectively, the "Games").
          This Privacy Policy explains how the Games handle information. By
          using the Games, you agree to the terms described here.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">1. Information We Collect</h2>
        <p className="mb-4">
          <strong>We do not collect, store, or share any personal information
          from users of our Games.</strong> The Games are designed to run
          entirely on your device and do not require an account, sign-in, or
          any personal data to play.
        </p>
        <p className="mb-4">
          Specifically, the Games do not collect:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li>Names, email addresses, phone numbers, or contact information</li>
          <li>Location data</li>
          <li>Photos, contacts, microphone, or camera input</li>
          <li>Device identifiers or advertising IDs</li>
          <li>Usage analytics or crash reports</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-3">2. Third-Party Services</h2>
        <p className="mb-4">
          The Games do not integrate third-party analytics, advertising, or
          tracking SDKs. We do not share any data with third parties because
          no data is collected.
        </p>
        <p className="mb-4">
          The Games are distributed through the Google Play Store. Google may
          collect limited information (such as install metrics) as part of its
          platform services, governed by Google's own privacy policy at{' '}
          <a
            href="https://policies.google.com/privacy"
            className="text-blue-600 hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            policies.google.com/privacy
          </a>.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">3. Children's Privacy</h2>
        <p className="mb-4">
          The Games are suitable for general audiences. Because we do not
          collect any personal information from any user, we likewise do not
          knowingly collect information from children under 13 (or the
          equivalent minimum age in your jurisdiction). The Games comply with
          the Children's Online Privacy Protection Act (COPPA) and Google
          Play's Families policy by collecting no personal data at all.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">4. Data Security</h2>
        <p className="mb-4">
          Because we do not collect or transmit personal data, there is no
          user data stored on our servers to secure. Any in-game preferences
          or progress are stored locally on your device.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">5. Your Rights</h2>
        <p className="mb-4">
          Since we do not collect personal information, there is no personal
          data to access, correct, export, or delete. You can uninstall the
          Games at any time to remove any locally stored data from your device.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">6. Changes to This Policy</h2>
        <p className="mb-4">
          We may update this Privacy Policy from time to time. When we do, we
          will revise the "Last updated" date at the top of this page.
          Continued use of the Games after changes are posted constitutes
          acceptance of the updated policy.
        </p>

        <h2 className="text-xl font-semibold mt-8 mb-3">7. Contact Us</h2>
        <p className="mb-4">
          If you have questions about this Privacy Policy, contact us at{' '}
          <a
            href={`mailto:${contactEmail}`}
            className="text-blue-600 hover:underline"
          >
            {contactEmail}
          </a>.
        </p>
      </div>
    </div>
  )
}

export default Privacy
